import { useEffect, useState } from "react";
import { fetchInsightBySlug, fetchTopInsight } from "../api/blog";
import { Loader } from "./ui/loader";


const Hero = () => {
  const [insight, setInsight] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
    
  useEffect(() => {
    const fetchData = async () => {
      //setIsLoading(true);
      try {
        const data = await fetchTopInsight();
        setInsight(data);
      } finally {
        //setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section
  className="relative h-screen max-h-[1000px] bg-cover bg-center flex items-center justify-center overflow-hidden"
  style={{ backgroundImage: "url('/main-background.png')" }}
>
          
      {/* Content */}
      <div className='bg-black bg-opacity-40'>
        <div className="grid lg:grid-cols-2 items-center h-[100vh] w-[100vw]">
          <div className="w-full px-4 md:px-0 md:ml-[110px] mb-[100px] mt-[85%] md:mt-[20%] lg:mt-[20%]">
            <h1 className="text-4xl sm:text-5xl lg:text-[75px] leading-tight lg:leading-[100px] tracking-normal lg:tracking-[0px] text-white mb-6">
              Strategic Precision.<br />
              <span>Lasting Impact.</span>
            </h1>

            <p className="text-white text-base sm:text-lg mb-8 leading-relaxed max-w-[650px]">
              Whether you're launching a fund, structuring a broker-dealer, or building the next 
              fintech disruptor; our playbooks, partners, and process get you there faster.
            </p>

            <button className="group bg-transparent text-white py-3 transition-all duration-300 text-sm font-medium tracking-wider inline-flex items-center" onClick={() => window.location.href = '/contact'}>
              LET'S BUILD TOGETHER
              <svg
                className="ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403807 8.98959 0.403807 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM0 6L-6.55671e-08 6.75L14 6.75L14 6L14 5.25L6.55671e-08 5.25L0 6Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          { insight && (<div className="lg:flex justify-end hidden mb-[50px] animate-slide-in-right mt-[16.5%]">
            <div className="p-2.5 border border-gray-800 max-w-sm w-[175px] h-[357.3px] bg-black h-auto">
              <div className="flex items-center space-x-3 mb-4">
                <div>
                  <img
                    src={insight?.title?.titleImage?.url}
                    alt="RIA Models"
                    className="mb-[5px] w-full h-[130px] transition-transform duration-300 ease-in-out hover:scale-105 pr-[7px]"
                  />
                  <div>
                    <h3 className="text-white text-[21.79px] font-medium ml-[10px] mt-[25px]">{insight?.title?.insightCategory}</h3>
                    <p className="text-[14.12px] font-semibold ml-[10px] mt-[15px] text-white">{insight?.title?.title}</p>
                  </div>
                </div>

              </div>
              <button 
                className="group text-white [display:ruby] ml-[10px] text-[13.47px] font-semibold " 
                onClick={() => window.location.href = `/insights/${insight?.slug}`}
              >
                <svg 
                  className='mr-[10px] transition-transform duration-300 group-hover:translate-y-[5px]' 
                  width="15" 
                  height="12" 
                  viewBox="0 0 15 12" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6.76884 10.9984C7.16618 11.3957 7.81039 11.3957 8.20772 10.9984L14.6827 4.5234C15.08 4.12606 15.08 3.48185 14.6827 3.08452C14.2853 2.68718 13.6411 2.68718 13.2438 3.08452L7.48828 8.84004L1.73276 3.08452C1.33542 2.68718 0.691216 2.68718 0.293881 3.08452C-0.103455 3.48185 -0.103455 4.12606 0.293881 4.5234L6.76884 10.9984ZM7.48828 0.511475L6.47084 0.511475L6.47084 10.2789L7.48828 10.2789L8.50572 10.2789L8.50572 0.511475L7.48828 0.511475Z" fill="white"/>
                </svg>
                READ MORE
              </button>
            </div>
          </div>
        )
        }
        </div>
      </div>
    </section>
  );
};

export default Hero;